import { createFileRoute } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';
import { ComingSoon } from '../../shell/page.js';

export const Route = createFileRoute('/_app/reports')({
  component: ReportsPage,
});

function ReportsPage() {
  return (
    <ComingSoon
      title="Reports"
      description="Waste, yields and stock value over time."
      icon={BarChart3}
      whatsComing="Reports on write-offs, production yields and stock value, exportable for your accountant."
    />
  );
}
